export default __webpack_public_path__ + "static/media/naans.c773224b.jpg";